import { axiosInstance } from "@helpers/axios-instance";
import { useQueryWithValidation } from "@/hooks/useQueryWithValidation";
import type { BalanceSheetWrapper, DataAwareResponse } from "@/types/types";

export function useBalanceSheet(id: string, isNonAssetBal = false, enabled = true) {
  const queryKey = isNonAssetBal ? "non-asset-balance-sheet" : "balance-sheet";

  return useQueryWithValidation<BalanceSheetWrapper>({
    queryFn: async () => {
      const { data } = await axiosInstance({
        method: "GET",
        url: `Salesforce/BalanceSheet/${id}?isNonAssetBal=${isNonAssetBal}`,
      });

      return data as DataAwareResponse<BalanceSheetWrapper>;
    },
    queryKey: [queryKey, id, String(isNonAssetBal)],
    enabled,
  });
}
